export default "__VITE_ASSET__ijD6S90q__"